import { lazy, Suspense, type CSSProperties } from "react";

import { COLUMN_CHART_HEIGHT, type ColumnChartProps } from "@/components/charts/types";
import { cn } from "@/lib/utils";

export type { ColumnChartProps, ColumnDatum, ColumnSeries } from "@/components/charts/types";

// recharts 는 차트 화면에서만 받는다 — 번들을 나누고, 크기를 재는 ResponsiveContainer 라 서버에서는 그리지 않는다.
const ColumnChartImpl = lazy(() => import("@/components/charts/column-chart-impl"));
const ChartSkeleton = () => <div aria-hidden className="h-full animate-pulse rounded-md bg-muted" />;

// 묶음 세로 막대 — 글자색은 muted-foreground, 계열 색은 series.tone 토큰 · 높이를 바깥에 박아 스켈레톤도 같은 높이(height ?? 기본값)다.
export const ColumnChart = ({ className, height, ...props }: ColumnChartProps & { className?: string }) => {
  const h = height ?? COLUMN_CHART_HEIGHT;
  return (
    <div className={cn("h-(--h) w-full text-muted-foreground", className)} style={{ "--h": `${h}px` } as CSSProperties}>
      <Suspense fallback={<ChartSkeleton />}>
        <ColumnChartImpl {...props} height={h} />
      </Suspense>
    </div>
  );
};
